// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Design tokens — single source of truth for color, type, spacing and motion. */
:root {
  /* Surfaces */
  --bg: #090b12;
  --bg-elevated: #0f121c;
  --surface: #141826;
  --surface-hover: #1b2032;
  --border: rgba(255, 255, 255, 0.08);
  --border-strong: rgba(255, 255, 255, 0.16);

  /* Text */
  --text: #f5f3ef;
  --text-muted: #a3a0b0;
  --text-faint: #6b6878;

  /* Brand — echoes the compass mark's orange-to-amber gradient */
  --accent-start: #f4511e;
  --accent-end: #ffb74d;
  --accent: #ff8a3d;
  --accent-soft: rgba(255, 138, 61, 0.14);

  /* Feedback */
  --like: #2dd4a7;
  --like-soft: rgba(45, 212, 167, 0.16);
  --dislike: #ff5c72;
  --dislike-soft: rgba(255, 92, 114, 0.16);

  /* Radius */
  --radius-sm: 6px;
  --radius-md: 12px;
  --radius-lg: 20px;
  --radius-full: 999px;

  /* Shadow */
  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.3);
  --shadow-md: 0 8px 24px rgba(0, 0, 0, 0.4);
  --shadow-lg: 0 20px 50px rgba(0, 0, 0, 0.55);
  --shadow-accent: 0 8px 24px rgba(255, 122, 61, 0.25);

  /* Motion */
  --ease: cubic-bezier(0.4, 0, 0.2, 1);
  --fast: 0.15s;
  --base: 0.25s;

  /* Type */
  --font-display: 'Fraunces', Georgia, serif;
  --font-body: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

* {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  padding: 0;
  min-height: 100%;
  font-family: var(--font-body);
  color: var(--text);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background:
    radial-gradient(1200px 600px at 15% -10%, rgba(255, 138, 61, 0.1), transparent 60%),
    radial-gradient(900px 500px at 90% 0%, rgba(79, 70, 229, 0.08), transparent 55%),
    var(--bg);
  background-attachment: fixed;
}

h1, h2, h3, h4, h5, h6 {
  font-family: var(--font-display);
  font-weight: 600;
  letter-spacing: -0.01em;
  margin: 0;
}

a {
  color: inherit;
}

button, input, textarea {
  font-family: inherit;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Slim, unobtrusive scrollbars everywhere */
* {
  scrollbar-width: thin;
  scrollbar-color: var(--border-strong) transparent;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: var(--border-strong);
  border-radius: var(--radius-full);
}

::-webkit-scrollbar-thumb:hover {
  background: var(--accent);
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,gFAAgF;AAChF;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,wBAAwB;EACxB,mCAAmC;EACnC,0CAA0C;;EAE1C,SAAS;EACT,eAAe;EACf,qBAAqB;EACrB,qBAAqB;;EAErB,+DAA+D;EAC/D,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;EACjB,uCAAuC;;EAEvC,aAAa;EACb,eAAe;EACf,qCAAqC;EACrC,kBAAkB;EAClB,wCAAwC;;EAExC,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;;EAEpB,WAAW;EACX,yCAAyC;EACzC,0CAA0C;EAC1C,4CAA4C;EAC5C,oDAAoD;;EAEpD,WAAW;EACX,oCAAoC;EACpC,aAAa;EACb,aAAa;;EAEb,SAAS;EACT,0CAA0C;EAC1C,+EAA+E;AACjF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC;EAClC;;;aAGW;EACX,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;aACW;AACb;;AAEA,4CAA4C;AAC5C;EACE,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* Design tokens — single source of truth for color, type, spacing and motion. */\n:root {\n  /* Surfaces */\n  --bg: #090b12;\n  --bg-elevated: #0f121c;\n  --surface: #141826;\n  --surface-hover: #1b2032;\n  --border: rgba(255, 255, 255, 0.08);\n  --border-strong: rgba(255, 255, 255, 0.16);\n\n  /* Text */\n  --text: #f5f3ef;\n  --text-muted: #a3a0b0;\n  --text-faint: #6b6878;\n\n  /* Brand — echoes the compass mark's orange-to-amber gradient */\n  --accent-start: #f4511e;\n  --accent-end: #ffb74d;\n  --accent: #ff8a3d;\n  --accent-soft: rgba(255, 138, 61, 0.14);\n\n  /* Feedback */\n  --like: #2dd4a7;\n  --like-soft: rgba(45, 212, 167, 0.16);\n  --dislike: #ff5c72;\n  --dislike-soft: rgba(255, 92, 114, 0.16);\n\n  /* Radius */\n  --radius-sm: 6px;\n  --radius-md: 12px;\n  --radius-lg: 20px;\n  --radius-full: 999px;\n\n  /* Shadow */\n  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.3);\n  --shadow-md: 0 8px 24px rgba(0, 0, 0, 0.4);\n  --shadow-lg: 0 20px 50px rgba(0, 0, 0, 0.55);\n  --shadow-accent: 0 8px 24px rgba(255, 122, 61, 0.25);\n\n  /* Motion */\n  --ease: cubic-bezier(0.4, 0, 0.2, 1);\n  --fast: 0.15s;\n  --base: 0.25s;\n\n  /* Type */\n  --font-display: 'Fraunces', Georgia, serif;\n  --font-body: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  min-height: 100%;\n  font-family: var(--font-body);\n  color: var(--text);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background:\n    radial-gradient(1200px 600px at 15% -10%, rgba(255, 138, 61, 0.1), transparent 60%),\n    radial-gradient(900px 500px at 90% 0%, rgba(79, 70, 229, 0.08), transparent 55%),\n    var(--bg);\n  background-attachment: fixed;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-family: var(--font-display);\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin: 0;\n}\n\na {\n  color: inherit;\n}\n\nbutton, input, textarea {\n  font-family: inherit;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Slim, unobtrusive scrollbars everywhere */\n* {\n  scrollbar-width: thin;\n  scrollbar-color: var(--border-strong) transparent;\n}\n\n::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--border-strong);\n  border-radius: var(--radius-full);\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--accent);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
